// Battery age comes from the API as a day count. Render as "Xy Ym",
// "Xm Yd", or "Xd" depending on magnitude. Centralized so detail panes
// and the work-task modal stay in sync — they used to disagree (one
// rendered 285 days as "9m 15d", the other as the literal "285 months").
export function formatDurationDays(days: number | null | undefined): string {
  if (days == null || !Number.isFinite(days) || days < 0) return '--';
  if (days > 365) return `${Math.floor(days / 365)}y ${Math.floor((days % 365) / 30)}m`;
  if (days > 30) return `${Math.floor(days / 30)}m ${days % 30}d`;
  return `${days}d`;
}
